import React, { useEffect, useState } from "react";
import { Navbar, SocialMedia, NavigationDots } from "./components";
import { About, Header, Footer, Skills, Work, Testimonial } from "./container";

const sections = ["home", "about", "work", "skills", "testimonials", "footer"];

function App() {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.42 }
    );

    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#030711] via-[#040f1a] to-[#02060d] text-slate-100 font-display relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 opacity-60">
        <div className="absolute -top-32 -left-10 w-[520px] h-[520px] bg-gradient-to-br from-primary/20 via-accent/25 to-transparent blur-3xl rounded-full" />
        <div className="absolute top-20 right-[-120px] w-[460px] h-[460px] bg-gradient-to-br from-accent/20 via-primaryDark/10 to-transparent blur-3xl rounded-full" />
        <div className="absolute bottom-[-200px] left-1/4 w-[720px] h-[720px] bg-white/5 blur-3xl rounded-full" />
      </div>

      <Navbar />

      <div className="hidden lg:flex fixed left-8 top-1/2 -translate-y-1/2 z-40">
        <SocialMedia />
      </div>
      <div className="hidden lg:flex fixed right-8 top-1/2 -translate-y-1/2 z-40">
        <NavigationDots active={activeSection} />
      </div>

      <div className="lg:hidden fixed bottom-6 right-6 z-40">
        <SocialMedia compact />
      </div>

      <main className="relative z-10 space-y-10">
        <Header />
        <About />
        <Work />
        <Skills />
        <Testimonial />
        <Footer />
      </main>
    </div>
  );
}

export default App;
